import _pick from 'lodash/pick';
import { ROUTES, QUERY, AUTHENTICATION_UI_TYPE, AUTH_ROUTER_PREFIX_DEFAULT } from './consts.js';

// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable max-statements */
const mockDomain = 'http://test.com';
const getLoginUrl = (options) => {
    const { webPath, returnUrl, loginType, esiaType, isNewWindow = false, isCrossDomains, otac, ot, pinDisabled, placement, productId, 
    // eslint-disable-next-line @typescript-eslint/naming-convention
    acr_values, hint, prompt, prefix = AUTH_ROUTER_PREFIX_DEFAULT, alfaClient, } = options || {};
    const hasWebPath = Boolean(webPath);
    const loginUrl = new URL(`${prefix}${ROUTES.LOGIN}`, hasWebPath ? webPath : mockDomain);
    if (returnUrl) {
        loginUrl.searchParams.append(QUERY.RETURN_URL, returnUrl);
    }
    if (loginType) {
        loginUrl.searchParams.append(QUERY.LOGIN_TYPE, loginType);
    }
    if (esiaType) {
        loginUrl.searchParams.append(QUERY.ESIA_TYPE, esiaType);
    }
    if (ot) {
        loginUrl.searchParams.append(QUERY.OT, ot);
    }
    if (otac) {
        loginUrl.searchParams.append(QUERY.OTAC, otac);
    }
    if (acr_values) {
        loginUrl.searchParams.append(QUERY.ACR_VALUES, acr_values);
    }
    if (hint) {
        loginUrl.searchParams.append(QUERY.HINT, hint);
    }
    if (prompt) {
        loginUrl.searchParams.append(QUERY.PROMPT, prompt);
    }
    if (isNewWindow) {
        loginUrl.searchParams.append(QUERY.TYPE, AUTHENTICATION_UI_TYPE.POPUP);
    }
    if (typeof isCrossDomains === 'boolean') {
        loginUrl.searchParams.append(QUERY.CROSS_DOMAINS_ACTIONS_ENABLED, isCrossDomains ? '1' : '0');
    }
    if (typeof pinDisabled === 'boolean') {
        loginUrl.searchParams.append(QUERY.PIN_DISABLED, pinDisabled.toString());
    }
    if (placement) {
        loginUrl.searchParams.append(QUERY.PLACEMENT, placement);
    }
    if (productId) {
        loginUrl.searchParams.append(QUERY.PRODUCT_ID, productId);
    }
    if (alfaClient) {
        loginUrl.searchParams.append(QUERY.ALFA_CLIENT, alfaClient);
    }
    return hasWebPath ? loginUrl.toString() : `${loginUrl.pathname}${loginUrl.search}`;
};
const getLogoutUrl = (options) => {
    const { webPath, prefix = AUTH_ROUTER_PREFIX_DEFAULT, isNewWindow = false, returnUrl } = options || {};
    const hasWebPath = Boolean(webPath);
    const logoutUrl = new URL(`${prefix}${ROUTES.LOGOUT}`, hasWebPath ? webPath : mockDomain);
    if (returnUrl) {
        logoutUrl.searchParams.append(QUERY.RETURN_URL, returnUrl);
    }
    if (isNewWindow) {
        logoutUrl.searchParams.append(QUERY.TYPE, AUTHENTICATION_UI_TYPE.POPUP);
    }
    return hasWebPath ? logoutUrl.toString() : `${logoutUrl.pathname}${logoutUrl.search}`;
};
const getLoadingUrl = (options) => {
    const { webPath, prefix = AUTH_ROUTER_PREFIX_DEFAULT, timeoutExpired } = options || {};
    const hasWebPath = Boolean(webPath);
    const loadingUrl = new URL(`${prefix}${ROUTES.LOADING}`, hasWebPath ? webPath : mockDomain);
    if (timeoutExpired)
        loadingUrl.searchParams.append(QUERY.TIMEOUT_EXPIRED, timeoutExpired.toString());
    return hasWebPath ? loadingUrl.toString() : `${loadingUrl.pathname}${loadingUrl.search}`;
};
/**
 * @deprecated Перенести генерауию урла в AuthApiClient
 */
const getSilentSignInUrl = (options) => {
    const { webPath, prefix = AUTH_ROUTER_PREFIX_DEFAULT } = options || {};
    const hasWebPath = Boolean(webPath);
    const silentSignInUrl = new URL(`${prefix}${ROUTES.SILENT_SIGNIN}`, hasWebPath ? webPath : mockDomain);
    return hasWebPath ? silentSignInUrl.toString() : `${silentSignInUrl.pathname}`;
};
/**
 * @deprecated Перенести генерауию урла в AuthApiClient
 */
const getSilentSignInVerifyUrl = (options) => {
    const { webPath, prefix = AUTH_ROUTER_PREFIX_DEFAULT } = options || {};
    const hasWebPath = Boolean(webPath);
    const silentSignInVerifyUrl = new URL(`${prefix}${ROUTES.SILENT_SIGNIN_VERIFY}`, hasWebPath ? webPath : mockDomain);
    return hasWebPath ? silentSignInVerifyUrl.toString() : `${silentSignInVerifyUrl.pathname}`;
};
/**
 * Cleanup user secret data
 * @param data - user data
 * @param keys - accepted keys
 * @returns IPublicUser - clean user data
 */
function formatUserData(data, keys = []) {
    const USER_CLAIMS = [
        'email',
        'phone_number',
        'exp',
        'expires',
        'name',
        'nickname',
        'preferred_username',
        'role',
        'sub',
        'given_name',
        'family_name',
        'avatar',
    ];
    const user = _pick(data, [...USER_CLAIMS, ...keys]);
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { given_name, family_name, ...rest } = user;
    return {
        ...rest,
        ...(given_name ? { first_name: given_name } : {}),
        ...(family_name ? { last_name: family_name } : {}),
    };
}

export { formatUserData, getLoadingUrl, getLoginUrl, getLogoutUrl, getSilentSignInUrl, getSilentSignInVerifyUrl };
//# sourceMappingURL=helpers.js.map
